import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=0c2dcb0e&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=0c2dcb0e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c2dcb0e",
  null
  
)

export default component.exports